import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packageItemWeight', packageItemWeight);

function packageItemWeight(splitService, $filter) {
  return function packageItemWeightFilter(item) {
    const weightConfig = $filter('translate')(splitService.getWeightUnit());
    const weightDisplay = item.weight ? item.weight : null;
    return !!weightDisplay ? weightDisplay + ' ' + weightConfig : null;
  }
}
